import { useContext } from 'react';
import { CurrencyContext } from 'src/contexts/CurrencyProvider';

export default function useCurrentCurrency() {
  return useContext(CurrencyContext)[0];
}
